import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apis from 'apis';

// Note: This file only for auto logout
const logout = createAsyncThunk('logout',
  async (token: any) => {
    const response = await apis.logout(token);
    return response.data;
  },
);

interface IInitialState {
  logoutStatus: string;
}

const initialState = {
  logoutStatus: '',
} as IInitialState;

export const counterSlice = createSlice({
  name: 'logout',
  initialState,
  reducers: {},
  extraReducers: {},
});

export {
  logout,
};
export default counterSlice.reducer;
